/* istanbul ignore file */
import { SvgIcon, SvgIconProps } from '@mui/material';

export const TipsIcon = (_props: SvgIconProps) => {
    return (
        <SvgIcon width="16" height="16" viewBox="0 0 16 16" fill="none">
            <rect width="16" height="16" rx="3" />
            <g clipPath="url(#clip0_7074_7454)">
                <path
                    d="M6.92551 4.73243C8.12409 3.5333 10.068 3.53376 11.2671 4.73243C12.4661 5.9311 12.4661 7.87517 11.2671 9.07431M9.97358 9.09607C9.97358 10.7919 8.59896 12.1666 6.90329 12.1666C5.20762 12.1666 3.83301 10.7919 3.83301 9.09607C3.83301 7.40027 5.20762 6.02555 6.90329 6.02555C8.59896 6.02555 9.97358 7.40027 9.97358 9.09607Z"
                    stroke="#F5FAFF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_7074_7454">
                    <rect
                        x="3"
                        y="3"
                        width="10"
                        height="10"
                        rx="2"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </SvgIcon>
    );
};
